import DropDown from '@/trio-ui/Dropdown';
import InputText from '@/trio-ui/InputText';
import { EmergencyContactRelationship } from '@/types/api';
import { emergencyRelationshipOptions } from '@/utils/staffMember';
import { Grid, InputWrapper } from './PersonalInfoEmergencyForm.styles';

type Props = {
  emergencyContactName: string;
  emergencyContactPhone: string;
  emergencyContactEmail: string;
  emergencyContactRelationship: string;
  onChange: (name: string, value: any) => void;
};

const PersonalInfoEmergencyForm = ({
  emergencyContactName,
  emergencyContactPhone,
  emergencyContactEmail,
  emergencyContactRelationship,
  onChange,
}: Props): JSX.Element => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>): void => {
    onChange(e.target.name, e.target.value);
  };

  return (
    <Grid>
      <InputWrapper>
        <InputText
          label="Name"
          name="emergencyContactName"
          value={emergencyContactName}
          onChange={handleChange}
        />
      </InputWrapper>
      <InputWrapper>
        <DropDown
          label="Relationship"
          options={emergencyRelationshipOptions}
          name="emergencyContactRelationship"
          defaultValue={emergencyContactRelationship as EmergencyContactRelationship}
          onChangeDropDown={handleChange}
        />
      </InputWrapper>
      <InputWrapper>
        <InputText
          label="Phone"
          name="emergencyContactPhone"
          value={emergencyContactPhone}
          onChange={handleChange}
        />
      </InputWrapper>
      <InputWrapper>
        <InputText
          label="Email"
          name="emergencyContactEmail"
          value={emergencyContactEmail}
          onChange={handleChange}
        />
      </InputWrapper>
    </Grid>
  );
};

export default PersonalInfoEmergencyForm;
